/* GENERATED FILE */
import React, { useContext, useMemo } from 'react';
import { IconProps, IconContext } from '../lib';

import bold from '../bold/ArrowsInLineHorizontal';
import duotone from '../duotone/ArrowsInLineHorizontal';
import fill from '../fill/ArrowsInLineHorizontal';
import light from '../light/ArrowsInLineHorizontal';
import regular from '../regular/ArrowsInLineHorizontal';
import thin from '../thin/ArrowsInLineHorizontal';

function ArrowsInLineHorizontal({ weight, color, size, style }: IconProps) {
  const {
    color: contextColor = '#000',
    size: contextSize = 24,
    weight: contextWeight = 'regular',
    style: contextStyle,
  } = useContext(IconContext);

  const IconComponent = useMemo(() => {
    const iconWeight = weight ?? contextWeight;

    const weightMap = {
      bold,
      duotone,
      fill,
      light,
      regular,
      thin,
    };

    return weightMap[iconWeight];
  }, [weight, contextWeight]);

  return (
    <IconComponent
      color={color ?? contextColor}
      size={size ?? contextSize}
      style={{
        ...contextStyle,
        ...style,
      }}
    />
  );
}

export default ArrowsInLineHorizontal;
